import i18next from 'i18next'
import React from 'react'
import { RootView } from '../../../libraries/root/root.template'

const mainClasses = ''
const chatClasses = ''

export const Main: RootView['Main'] = ({ menuOpen, pageKind, isFullScreenPage, children }) =>
  isFullScreenPage ? (
    children
  ) : (
    <main
      lang={i18next.language}
      id="a11y-main"
      className={`main main--${pageKind} ${mainClasses}`}
      inert={menuOpen ? '' : undefined}
    >
      <article className="page"> {/* style={{ overflowX: 'hidden' }} */}
        {children}
      </article>
    </main>
  )
